const getSortOrder = ({ labelCache, label }) => {
  const { order, parentId } = label;
  // children should be sorted relative to their parent order *and* theirs
  if (parentId) {
    return Number.parseFloat(`${labelCache[parentId].order}.${order}`);
  }
  return order;
};

export default ({ subjectLabels }) => {
  if (subjectLabels.length === 0) {
    return {};
  }

  const labelCache = subjectLabels.reduce(
    (accumulator, label) => ({
      ...accumulator,
      [label?.labelId]: { ...label },
    }),
    {},
  );

  // ensure the labels are rendered in the correct order based on the order field
  // this allows us correctly set an index on each label and A LOT more easily
  // meet a11y requirements
  const sortedLabels = Object.values(labelCache).sort((a, b) => {
    // sorting of a some child and some parent where the parent and child are related: descending
    // additional sorting labels by co-teacher, using userId. FY-31496
    if (a.userId !== b.userId) {
      return a.userId - b.userId;
    }

    if (a.labelId === b.parentId) {
      return -1;
    }

    if (b.labelId === a.parentId) {
      return 1;
    }

    // every other time, sort ascending
    const aSortOrder = getSortOrder({ labelCache, label: a });
    const bSortOrder = getSortOrder({ labelCache, label: b });

    return aSortOrder - bSortOrder;
  });

  // build an ordered hierarchy
  // NOTE, keys are automatically sorted by JS so we need to calculate parents separately
  // if we want to get them in order
  const parents = [];
  const orderedParentChildHierarchy = sortedLabels.reduce(
    (accumulator, label, index) => {
      const { parentId, labelId } = label;

      // used for a11y
      labelCache[labelId].index = index;
      labelCache[labelId].lastIndex = subjectLabels.length - 1;

      if (!parentId) {
        parents.push(labelId);
        return {
          ...accumulator,
          [labelId]: [...(accumulator[labelId] || [])],
        };
      }

      return {
        ...accumulator,
        [parentId]: [...(accumulator[parentId] || []), labelId],
      };
    },
    {},
  );

  return {
    labels: labelCache,
    parents,
    children: orderedParentChildHierarchy,
  };
};
